import { Link } from 'react-router-dom';
import './client-portal.css';

/**
 * Contenido real de "Análisis técnico" y "Documentación" queda para
 * Fase C/D/E — acá solo confirma que la ruta protegida funciona.
 */
export function ClientPortalPlaceholder({ title }: { title: string }): JSX.Element {
  return (
    <div className="portal-placeholder">
      <h1>{title}</h1>
      <p>En construcción.</p>
      <Link to="/">Volver al panel</Link>
    </div>
  );
}
